import Div from "@jumbo/shared/Div";
import { Button, InputAdornment, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ListFactoryTable from "./factoryTable";
import { useDispatch } from "react-redux";
import { getAllFactory } from "app/redux/actions/masterAction";
// import ListSupplierTable from "./supplierTable";

export default function ListFactory() {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  const [page, setPage] = useState(1);
  const handleSearch = (value) => {
    setPage(1);
    dispatch(getAllFactory(value, 1));
  };
  useEffect(() => {
    dispatch(getAllFactory());
  }, []);
  return (
    <Div sx={{ mt: -4 }}>
      <Typography variant="h1">Factory Master</Typography>
      <Div
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <TextField
          size="small"
          id="search"
          type="search"
          label="Search"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            handleSearch(e.target.value);
          }}
          sx={{ width: 300, mb: 5, mt: 4 }}
          InputProps={{
            endAdornment: (
              <Div sx={{ cursor: "pointer" }}>
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              </Div>
            ),
          }}
        />
        {permissions?.factory_master_create == true && (
          <Div>
            <Button
              variant="contained"
              sx={{ p: 1, pl: 4, pr: 4 }}
              onClick={() => navigate("/master/factory/add")}
            >
              Add New Factory
            </Button>
          </Div>
        )}
      </Div>
      <ListFactoryTable searchTerm={searchTerm} setPage={setPage} page={page} />
    </Div>
  );
}
